import {VariantType} from "notistack";
import { t } from 'i18next'

export function handleErrorMessage(errorStatus : number) : string {
    if(errorStatus === 401)return t("text.resourceUnauthorized");
    else if(errorStatus  >= 400 && errorStatus < 500) return t("text.resourceNotFound")
    else return t("text.unknownError")
}
export function handleErrorVariant(errorStatus : number) :VariantType {
    if(errorStatus === 401)return 'error';
    else if(errorStatus  >= 400 && errorStatus < 500) return 'error'
    else return 'warning'
}